import React, { memo } from 'react';
import {
  object, string, number,
} from 'prop-types';
import { connectCommonProps } from '../../../shared/utils/CommonPropsContext';
import { currency } from '../Currency';
import { dateTime } from '../DateTime';

const InstallmentsItem = ({
  dueDate, locale, remainingBalance, currencyCode,
}) => {
  const i18nDateTime = dateTime({ date: dueDate, locale });
  const i18nAmountDue = currency({ amount: remainingBalance, code: currencyCode, locale });

  return <div
    className="installments-list__item">
    <div className="installments-list__item-date">
      {i18nDateTime}
    </div>
    <div className="installments-list__item-amount">
      {i18nAmountDue}
    </div>
  </div>;
};

InstallmentsItem.propTypes = {
  remainingBalance: number,
  currencyCode: string,
  dueDate: object,
  locale: string,
};

InstallmentsItem.defaultProps = {
  locale: 'en_US',
};

export default connectCommonProps(memo(InstallmentsItem));
